export default {
  methods: {
    getMicroflowParameters(parameters) {
      if (!parameters) {
        return {}
      }

      const microflowProps = {}
      for (const key in parameters) {
        if (Object.hasOwnProperty.call(parameters, key)) {
          microflowProps[key] = {}
          let propValue = this.getExternalSourceField(parameters[key])
          // let propValue = this.getDataSourceField(microflowPropsModel[key])
          let propType = ''
          // get type of the prop
          switch (typeof propValue) {
            case 'string':
              propType = 'System.String'
              break
            case 'number':
              propType = 'System.Int32'
              break
            case 'boolean':
              propType = 'bool'
              break
            default:
              propType = 'object'
              break
          }

          microflowProps[key].ParameterType = propType
          // serialize prop value
          microflowProps[key].SerializedValue = JSON.stringify(propValue)
        }
      }

      return microflowProps
    }
  }
}